<template>
  <div :class="['quad-pack', {'static': !animated}]">
    <div ref="root" class="root" />
  </div>
</template>

<script>
import { select as d3_select } from 'd3-selection'
// eslint-disable-next-line
import { transition } from 'd3-transition'
import Size from '../mixins/Size'
import NicePacking from '../utils/NicePacking'
export default {
  name: 'QuadPack',
  mixins: [Size],
  props: {
    proportions: {
      type: Array,
      required: true,
    },
    animated: {
      type: Boolean,
      default: true,
    },
    maxIngredients: {
      type: Number,
      default: 7,
    },
    transitionDuration: {
      type: Number,
      default: 600,
    },
  },
  watch: {
    proportions: function () {
      this.draw()
    },
    size: {
      handler() {
        this.draw()
      },
    },
  },
  mounted() {
    this.draw()
  },
  methods: {
    draw() {
      const height = 100
      const width = 100
      const packMargin = 4

      let pack = NicePacking()
        .size([width, height])
        .value(d => d.proportion)

      var data = JSON.parse(JSON.stringify(this.proportions))

      // WHAT KIND OF BULLSHIT!!!
      // if (this.heroIngredient) {
      //   let candidate = data.find(p => p.ingredient.id === this.heroIngredient.id)
      //   if (candidate) candidate.proportion *= 2
      // }

      data.sort((a, b) => b.proportion - a.proportion)
      data = data.filter(d => d.proportion > 0).slice(0, this.maxIngredients)

      let packData = pack(data)

      let items = d3_select(this.$refs.root)
        .selectAll('.item')
        .data(packData, d => d.data.ingredient.id)
      let itemsEnter = items.enter().append('div').attr('class', 'item')
      itemsEnter.on('click', (e, d) => {
        // this.onSelect && this.onSelect(d.data.ingredient.id)
        this.$emit('select', d.data.ingredient)
      })
      itemsEnter
        .style('position', 'absolute')
        .style('left', function (d) {
          return 'calc( ' + d.x0 + '% + ' + packMargin / 2 + 'px)'
        })
        .style('top', function (d) {
          return 'calc( ' + d.y0 + '% + ' + packMargin / 2 + 'px)'
        })
        .style('width', function (d) {
          return 'calc( ' + (d.x1 - d.x0) + '% - ' + packMargin + 'px)'
        })
        .style('height', function (d) {
          return 'calc( ' + (d.y1 - d.y0) + '% - ' + packMargin + 'px)'
        })
        // .style('cursor', d => {
        //   return d.data.ingredient.isIngredientChapter ? 'pointer' : 'auto'
        // })
        .style('cursor', this.$listeners?.select ? 'pointer' : 'auto')
        .style('opacity', 0)

      itemsEnter
        .append('div')
        .attr('class', 'ing-name')
        .append('div')
        .attr('class', 'ing-name-label')
        .text(d => d.data.ingredient.name)

      // let defaultColorClass = this.defaultColor === 'HEAVY' ? ' black' : ' white'
      // itemsEnter.classed((defaultColorClass), true)
      itemsEnter.classed(
        'white',
        d => d.data.ingredient.imageUrl !== d.data.ingredient.heavyImageUrl
      )
      itemsEnter.classed(
        'black',
        d => d.data.ingredient.imageUrl === d.data.ingredient.heavyImageUrl
      )
      itemsEnter.each(function (d) {
        let img = new Image()
        img.onload = () => {
          d3_select(this).append(() => img)
        }
        img.onerror = () => {
          if (d.data.ingredient.family)
            d3_select(this).style('background-color', d.data.ingredient.family.color)
          else d3_select(this).classed('no-image', true)
          // d3_select(this).append('div').attr('class','ing-name').text(d.data.ingredient.name)
        }
        img.src = d.data.ingredient.imageUrlM || d.data.ingredient.imageUrl
        // img.src = imageProvider.getImageUrl('ingredients/'+d.data.ingredient.imageUrl)
      })

      // itemsEnter.on('click', (e, d) => {
      //   if (d.data.ingredient.isIngredientChapter)
      //     this.$router.push(`/chapter/ingredient?data=${d.data.ingredient.id}`)
      // })
      let itemsExit = items.exit()
      itemsExit
        // .interrupt()
        .transition('exit')
        .duration(this.transitionDuration)
        .style('opacity', 0)
        .remove()
      itemsEnter
        // .interrupt()
        .transition('enter')
        .duration(this.transitionDuration)
        .delay((d, i) => (i * this.transitionDuration) / this.maxIngredients)
        .style('opacity', 1)
      // items.transition('enter').duration(this.transitionDuration).style('opacity', 1)
      // console.log('FUCK', itemsEnter.nodes().length, items.nodes().length, itemsExit.nodes().length)
      items = items.merge(itemsEnter)
      items.classed('selected', d => {
        return this.selection && d.data.ingredient.id === this.selection
      })
      items.classed('unselected', d => {
        return this.selection && d.data.ingredient.id !== this.selection
      })
      items
        .style('left', function (d) {
          return 'calc( ' + d.x0 + '% + ' + packMargin / 2 + 'px)'
        })
        .style('top', function (d) {
          return 'calc( ' + d.y0 + '% + ' + packMargin / 2 + 'px)'
        })
        .style('width', function (d) {
          return 'calc( ' + (d.x1 - d.x0) + '% - ' + packMargin + 'px)'
        })
        .style('height', function (d) {
          return 'calc( ' + (d.y1 - d.y0) + '% - ' + packMargin + 'px)'
        })
      // if (this.animated) {
      //   items
      //     .transition()
      //     .duration(600)
      //     .delay((d, i) => i * 100)
      //     .style('opacity', 1)
      // } else {
      //   items.style('opacity', 1)
      // }

      items
        .select('.ing-name')
        .select('.ing-name-label')
        .text(d => d.data.ingredient.name)
    },
  },
}
</script>

<style scoped lang="stylus">
.quad-pack
  position: relative

  &:after
    display: block
    padding-bottom: 100%
    content: ""

  .root
    position: absolute
    width: 100%
    height: 100%

    >>> .item
      overflow: hidden
      background-position: center
      background-size: cover
      background-repeat: no-repeat
      transition: width 0.4s ease-in-out, height 0.4s ease-in-out, top 0.4s ease-in-out, left 0.4s ease-in-out

      // background: #f0a !important;
      &.no-image
        display: flex
        flex-direction: column
        justify-content: center

        &.black
          background: #000
          color: #fff

        &.white
          background: #fff
          color: #000

        img
          display: none

      &.selected,
      &.unselected
        opacity: 0.5 !important

      img
        overflow: hidden
        width: 100%
        height: 100%
        transition: filter 0.6s
        object-fit: cover

      .ing-name
        position: absolute
        z-index: 1
        width: 100%
        height: 100%
        background: rgba(255, 255, 255, 0.5)
        opacity: 0
        transition: opacity 0.3s

        .ing-name-label
          position: absolute
          top: 50%
          left: 50%
          text-align: center
          // m-font("Lelo", "regular")
          // m-font-size(14, 16)
          font-weight: bold
          transform: translate(-50%, -50%)

      &.black
        .ing-name
          background: rgba(0, 0, 0, 0.5)

          .ing-name-label
            color: #fff
            text-shadow: 0 1px 10px #000

      &.white
        .ing-name
          background: rgba(255, 255, 255, 0.5)

          .ing-name-label
            color: #000
            text-shadow: 0 1px 10px #fff

      &:hover
        .ing-name
          opacity: 1

        img
          filter: blur(4px)
</style>